<template>
  <ul
    class="nav nav-tabs header-tabs nav-tabs-sm nav-overflow flex-wrap"
    v-if="vendor"
  >
    <li class="nav-item">
      <router-link
        :to="`/vendors/${vendor.id}`"
        class="nav-link vendor-nav-link"
        data-v-step="vendorProfile"
      >
        <icon type="user-tie" /> Profile
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="`/vendors/${vendor.id}/locations`"
        class="nav-link vendor-nav-link"
        data-v-step="vendorLocations"
      >
        <icon type="map-marker-alt" /> Locations
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="`/vendors/${vendor.id}/contacts`"
        class="nav-link vendor-nav-link"
        data-v-step="vendorContacts"
      >
        <icon type="users" /> Contacts
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="`/vendors/${vendor.id}/billing`"
        class="nav-link vendor-nav-link"
        data-v-step="vendorBillings"
      >
        <icon type="credit-card" /> Billing
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="`/vendors/${vendor.id}/intake-form`"
        class="nav-link vendor-nav-link"
        data-v-step="vendorIntakeForm"
      >
        <icon type="file-alt" /> Intake Form
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="`/vendors/${vendor.id}/network/requests`"
        class="nav-link vendor-nav-link d-flex align-items-center"
        data-v-step="vendorNetwork"
      >
        <icon type="project-diagram" class="mr-2" /> Network
        <div
          class="ml-2 badge badge-dark font-weight-bold"
          v-if="vendor.networks_requests_count"
        >
          {{ vendor.networks_requests_count }}
        </div>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="`/vendors/${vendor.id}/followers`"
        class="nav-link vendor-nav-link d-flex align-items-center"
        data-v-step="vendorFollowers"
      >
        <icon type="heart" class="mr-2" /> Followers
        <div
          class="ml-2 badge badge-dark font-weight-bold"
          v-if="vendor.followers_count"
        >
          {{ vendor.followers_count }}
        </div>
      </router-link>
    </li>
  </ul>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Nav",
  computed: {
    ...mapState(["vendors"]),
    vendor: function () {
      return this.vendors.single;
    },
  },
};
</script>
